import { useFiltersContext } from "../contexts/FiltersContext";
import { useLockersContext } from "../contexts/LockersContext";
import { LockerService } from "../services/lockerService";
import { Filters } from "./FiltersComponent";
import LockerListContainer from "./LockerListContainer";
import NoResults from "./NoResultsFound";
import PlaceSelectorContainer from "./PlaceSelectorContainer";

const SwitchVisibleComponent = (): JSX.Element | null => {
    const { lockerResponse } = useLockersContext();
    const { showFilters } = useFiltersContext();

    if (showFilters) {
        return <Filters />
    }
    if (LockerService.isAnyLockerSelected()) {
        return <PlaceSelectorContainer/>
    }
    if (lockerResponse.length > 0) {
        return <LockerListContainer/>
    }
    return <NoResults/>
}

export default SwitchVisibleComponent;